import { createStyles, makeStyles } from "@material-ui/core";
import produitImg from "assets/icons/default_product_picture.svg";
import { FadeInDownDiv } from "components/Animations/FadeInDown";
import { DefaultInfo } from "components/NothingRight";  
import i18n from "config/i18n";
import useText from "constants/text";
import { Product } from "generated/graphql";
import { BoxIcon, PriceIcon } from "icons";
import React from "react";
import { Button } from "ui/Button";

interface RightSideCatalogProps {
  product: Product;
  onDeleteHandled?: (product: Product) => void;
  onUpdateHandled?: (product: Product) => void;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      overflowY: "scroll",
      height: "94vh",
    },
    topTitle: {
      fontWeight: 900,
      color: "rgba(117, 122, 147, 0.64)",
      fontSize: 24,
      marginBottom: 10,
      marginTop:10
    },
    img: {
      height: "100%",
      width: 307,
    },
    imgContent: {
      width: "100%",
      height: 307,
      display: "flex",
      justifyContent: "space-evenly",
    },
    name: {
      textTransform: "uppercase",
      fontWeight: 900,
      color: theme.palette.primary.main,
      marginTop: 10,
    },
    category: {
      marginTop: 10,
      fontWeight: 900,
      color: "#373738",
      fontSize: "16px",
    },
    description: {
      marginTop: 10,
      color: "#A3A3A3",
      fontSize: "12",
    },
    lineProperties: {
      marginTop: 20,
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    lineItem: {
      color: "#5a525b",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-evenly",
      "&>span": {
        marginLeft: 2,
      },
    },
    buttons: {
      marginTop: 45,
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
    },
    button: {
      width: "40%",
      textTransform: "uppercase",
      "&.MuiButton-outlinedSecondary": {
        color: "#e53935",
        border: "1px solid #e53935",
      },
    },
  })
);

export function RightSideCatalog({ product = null, onDeleteHandled, onUpdateHandled }: RightSideCatalogProps) {
  const styles = useStyles();
  const text = useText();

  const lng = React.useMemo(
    () => (i18n.language.toLocaleUpperCase() === "FR" ? 0 : 1),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n.language]
  );

  const handleDelete = () => {
    onDeleteHandled(product);
  };

  const renderProduct = () => (
    <FadeInDownDiv>
      <div className={styles.root}>
        <div className={styles.topTitle}>{text.text.catalog.article_detail}</div>
        <div className={styles.imgContent}>
          <img className={styles.img} alt={product.name} src={product.photoUrl ?? produitImg} />
        </div>
        <div className={styles.name}> {product.name} </div>
        <div className={styles.category}>
          {product.category.translations && product.category.translations[lng]?.text}
        </div>
        <div className={styles.description}>{product.description}</div>
        <div className={styles.lineProperties}>
          <div className={styles.lineItem}>
            <span>
              <BoxIcon color="#f69833" height={24} width={24} />
            </span>
            <span>{product.weight}</span>
          </div>
          <div className={styles.lineItem}>
            <span>
              <PriceIcon color="#f69833" height={24} width={24} />
            </span>
            {product.value} XOF
          </div>
          <div className={styles.lineItem}>
            <span>{product.code}</span>
          </div>
        </div>
        <div className={styles.buttons}>
          <Button variant="outlined" color="secondary" className={styles.button} onClick={handleDelete}>
            {text.text.all.delete}
          </Button>
          <Button variant="outlined" color="primary" className={styles.button} onClick={() => onUpdateHandled(product)}>
            {text.text.all.edit}
          </Button>
        </div>
      </div>
    </FadeInDownDiv>
  );
  return <>{product ? renderProduct() : <DefaultInfo />}</>;
}
